import type { FC, ReactNode } from 'react'

import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StarsProps {
    className?: string
}

export const Stars: FC<StarsProps> = ({ className }): ReactNode => (
    <span className={cn('inline-flex gap-0.5', className)} role='img' aria-label='5 av 5 stjerner'>
        {Array.from({ length: 5 }).map((_, index) => (
            <Star key={index} className='size-3.5 fill-current' strokeWidth={0} aria-hidden='true' />
        ))}
    </span>
)
